function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 5.32,
  y: 1.5,
  width: 13.36,
  height: 21,
  fill: "none",
  stroke: "#EB008B",
  strokeWidth: 1.91,
  strokeMiterlimit: 10
});
var _ref3 = /*#__PURE__*/React.createElement("line", {
  x1: 8.18,
  y1: 5.32,
  x2: 10.09,
  y2: 5.32,
  stroke: "#EB008B",
  strokeWidth: 1.91,
  strokeMiterlimit: 10
});
var _ref4 = /*#__PURE__*/React.createElement("line", {
  x1: 8.18,
  y1: 9.14,
  x2: 10.09,
  y2: 9.14,
  stroke: "#EB008B",
  strokeWidth: 1.91,
  strokeMiterlimit: 10
});
var _ref5 = /*#__PURE__*/React.createElement("line", {
  x1: 8.18,
  y1: 12.95,
  x2: 10.09,
  y2: 12.95,
  stroke: "#EB008B",
  strokeWidth: 1.91,
  strokeMiterlimit: 10
});
var _ref6 = /*#__PURE__*/React.createElement("line", {
  x1: 11.05,
  y1: 5.32,
  x2: 12.95,
  y2: 5.32,
  stroke: "#EB008B",
  strokeWidth: 1.91,
  strokeMiterlimit: 10
});
var _ref7 = /*#__PURE__*/React.createElement("line", {
  x1: 11.05,
  y1: 9.14,
  x2: 12.95,
  y2: 9.14,
  stroke: "#EB008B",
  strokeWidth: 1.91,
  strokeMiterlimit: 10
});
var _ref8 = /*#__PURE__*/React.createElement("line", {
  x1: 11.05,
  y1: 12.95,
  x2: 12.95,
  y2: 12.95,
  stroke: "#EB008B",
  strokeWidth: 1.91,
  strokeMiterlimit: 10
});
var _ref9 = /*#__PURE__*/React.createElement("line", {
  x1: 13.91,
  y1: 5.32,
  x2: 15.82,
  y2: 5.32,
  stroke: "#EB008B",
  strokeWidth: 1.91,
  strokeMiterlimit: 10
});
var _ref10 = /*#__PURE__*/React.createElement("line", {
  x1: 13.91,
  y1: 9.14,
  x2: 15.82,
  y2: 9.14,
  stroke: "#EB008B",
  strokeWidth: 1.91,
  strokeMiterlimit: 10
});
var _ref11 = /*#__PURE__*/React.createElement("line", {
  x1: 13.91,
  y1: 12.95,
  x2: 15.82,
  y2: 12.95,
  stroke: "#EB008B",
  strokeWidth: 1.91,
  strokeMiterlimit: 10
});
var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 9.14,
  y: 17.73,
  width: 5.73,
  height: 4.77,
  fill: "none",
  stroke: "#EB008B",
  strokeWidth: 1.91,
  strokeMiterlimit: 10
});
var _ref13 = /*#__PURE__*/React.createElement("polygon", {
  points: "5.32 22.5 1.5 22.5 1.5 13.91 5.32 12 5.32 22.5",
  fill: "none",
  stroke: "#EB008B",
  strokeWidth: 1.91,
  strokeMiterlimit: 10
});
var _ref14 = /*#__PURE__*/React.createElement("polygon", {
  points: "18.68 22.5 22.5 22.5 22.5 13.91 18.68 12 18.68 22.5",
  fill: "none",
  stroke: "#EB008B",
  strokeWidth: 1.91,
  strokeMiterlimit: 10
});
var SvgApartmentsHouseMagenta = function SvgApartmentsHouseMagenta(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgApartmentsHouseMagenta, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/apartments-house-magenta.9448fa41.svg";
export { ForwardRef as ReactComponent };